import { Card, CardContent, Grid } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useFormikContext } from 'formik'
import type { User } from '@paintscout/api'
import {
  FloatingMenu,
  UserAccountForm,
  // UserMiscForm,
  UserEmailForm,
  FollowUpsForm,
  UserNotificationsForm
} from '@ui/stickybid'
import { getFeature } from '@paintscout/util/builder'
import type { OptionsDocument } from 'paintscout'

export interface UserProfileFormProps {
  section?: string

  onSectionChange?: (section: string) => any
}

export default function UserProfileForm({ section = 'account', onSectionChange }: UserProfileFormProps) {
  const [menuValue, setMenuValue] = useState(section)
  const { values, handleSubmit } = useFormikContext<{ user: User; options: OptionsDocument }>()
  const { user, options } = values
  const hasUserFollowUps = getFeature({ options, path: 'quotes.followUps.userFollowUps.enabled' })

  // update if url changes
  useEffect(() => {
    setMenuValue(section)
  }, [section])

  function handleMenuItemClick(item) {
    if (onSectionChange) {
      onSectionChange(item.key)
    }
    setMenuValue(item.key)
  }

  const menuItems = [
    {
      key: 'account',
      label: 'Account'
    },
    {
      key: 'email',
      label: 'Emails'
    },
    hasUserFollowUps && { key: 'follow-ups', label: 'Follow-Ups' },
    {
      key: 'notifications',
      label: 'Notifications'
    }
    // {
    //   key: 'misc',
    //   label: 'Misc.'
    // }
  ].filter(Boolean)

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} xl={2}>
        <FloatingMenu
          value={menuValue}
          defaultValue="account"
          items={menuItems}
          onItemClick={handleMenuItemClick}
          collapseOn="lg"
        />
      </Grid>
      <Grid item xs={12} xl={10}>
        <Card>
          <CardContent>
            {menuValue === 'account' && <UserAccountForm allowEmailChange showChangePassword={false} />}
            {/* {menuValue === 'misc' && <UserMiscForm />} */}
            {menuValue === 'email' && <UserEmailForm />}
            {menuValue === 'follow-ups' && (
              <FollowUpsForm type={'user'} userId={user.user_id} onDialogConfirm={handleSubmit} />
            )}
            {menuValue === 'notifications' && <UserNotificationsForm showAdmin={true} />}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}
